import React from 'react';
import { FaPhone } from 'react-icons/fa';

const PhoneNumber = () => {

    return (
        <a 
        href="tel:+919523124709" 
        style={{ color: '#000000', fontSize: '16px', textDecoration: 'None'  }}
        >
        +91-9523124709 <FaPhone /> 
        </a>
        
    );
};

export default PhoneNumber;